<template>
  <div class="showcase">
    <div class="row row-cols-3 g-0">
      <div
        class="image-container col"
        v-for="cases in caseData"
        :key="cases._id"
      >
        <ImageList :data="cases" class="showcase-image" />
      </div>
    </div>
  </div>
</template>

<script>
import ImageList from "./ImageList.vue";

export default {
  name: "AboutUs",
  components: { ImageList },
  props: ["caseData"],
};
</script>

<style scoped>
.image-container {
  overflow: hidden;
}

.showcase-image {
  height: 450px;
  width: 100%;
  object-fit: cover;
  transition: all 0.5s ease-out;
}

.showcase-image:hover {
  transform: scale(1.05);
}
</style>
